/* eslint-disable */
/* @ts-ignore */
import { HttpHeaders } from '@angular/common/http';
import { MicroserviceId } from './microservices.const';
import { RequestMethods } from './request-method.model';

export class ApiConfig {
    name: string;
    url: string;
    method: string;
    service?: MicroserviceId; // Indicates which microservice this API belongs to
    headers?:
        | HttpHeaders
        | {
              [header: string]: string | string[];
          };
    timeout?: number;

    constructor(api: ApiConfig) {
        this.name = api.name || '';
        this.url = api.url;
        this.method = (api.method || RequestMethods.GET).toUpperCase();
        this.service = api.service;
        this.headers = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
        if (api.headers) {
            for (const key in api.headers) {
                /* @ts-ignore */
                if (api.headers[key]) {
                    /* @ts-ignore */
                    this.headers = this.headers.set(key, api.headers[key].toString());
                }
            }
        }
        this.timeout = api.timeout || 30000;
    }
}
